/* mf-pdp-c.js - the "Egyszerű (C)" product page (Theme settings > Termékoldal = C), RO 2026-10-06.
   Loaded by snippets/mf-pdp-c.liquid right after product-rhode's own script, so every live element is already
   built (type cards, swatches, MagSafe toggle, protector and gift cards, CTA, float bar). C's controls DRIVE those
   live elements - a pick in the case-type dropdown clicks the live type card, the Pro-Shield row presses / releases
   the live Pro-Shield card and the NanoGlass row the live NanoGlass card (two independent ticks, like the live
   cards), the green Mystery Cadou strip arms or disarms the live gift card - so the cart, prices, line properties,
   the glossy merge and the tracking stay the live code. What this file adds on its own: the dropdown, the gallery
   dots, the 1+1 strip's place (right under the price), the CTA / float bar labels (case + every ticked folie), the
   accessory set's add, the accordions, and the mf-track steps a synthetic click would lose (mf-track counts trusted
   clicks only). assets/mf-pdp-d.js (D only) runs after this file and drives these controls. In the C/D test
   (Termékoldal = 'cd') this file runs for both arms; D is the arm whose section carries .mfpd (window.__mfPF 'd'). */
(function () {
  'use strict';
  var D = document, W = window;
  var root = D.querySelector('.pr.mfc[data-pr]');
  if (!root || root.__mfc) { return; }
  root.__mfc = true;

  var cfg = {}, data = {};
  try { cfg = JSON.parse((D.querySelector('[data-mfc-data]') || {}).textContent || '{}'); } catch (e0) {}
  try { data = JSON.parse((D.querySelector('[data-pr-data]') || {}).textContent || '{}'); } catch (e1) {}
  var rm = W.matchMedia ? W.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function smooth() { return rm && rm.matches ? 'auto' : 'smooth'; }
  function $(s, r) { return (r || root).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || root).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function raf(fn) { var q = 0; return function () { if (q) { return; } q = W.requestAnimationFrame(function () { q = 0; fn(); }); }; }
  function push(ev, p) { try { if (W.mfTrackPush) { W.mfTrackPush(ev, p); } } catch (e) {} }
  function step(n) { push('mf_nav_step', { mf_step: n }); }
  /* element measurement (2026-10-07): one key per fact per pageview (the beacon dedupes per pageview anyway; this
     also keeps GA4 to one event per fact). A key counts as sent only once mf-track's public push exists. */
  var sentK = {};
  function step1(n) { if (sentK[n] || !W.mfTrackPush) { return; } sentK[n] = 1; step(n); }
  var CAR = '<svg class="mfc-car" viewBox="0 0 10 10" aria-hidden="true"><path d="M1 3h8L5 7.6z"/></svg>';

  /* money: the section's own formatter (shop.money_format, whole RON without decimals), and its reverse for the
     texts that formatter wrote */
  var fmt = String(data.moneyFormat || '');
  var amountRe = new RegExp('\\{\\{\\s*amount[^}]*\\}\\}');
  /* RO formats {{amount_no_decimals}}: like the Liquid money filter and the drawer, a 45,50 accessory reads 46 RON */
  var noDec = /no_decimals/.test((fmt.match(amountRe) || [''])[0]);
  function money(c) {
    var v = (c || 0) / 100;
    var s = noDec ? String(Math.round(v)) : ((v % 1 === 0) ? v.toFixed(0) : v.toFixed(2).replace('.', ','));
    return amountRe.test(fmt) ? fmt.replace(amountRe, s) : s + ' RON';
  }
  function cents(t) {
    var x = String(t || '').replace(/[^\d.,]/g, '');
    if (!x) { return 0; }
    var p = x.split(',');
    return (parseInt(p[0].replace(/\./g, ''), 10) || 0) * 100 + (p.length > 1 ? (parseInt((p[1] + '00').slice(0, 2), 10) || 0) : 0);
  }

  /* mf-track's depth blocks read the FIRST .pr-routine in the document: C's upsell rows are that block now, the
     hidden live set steps aside */
  $$('.pr-routine:not(.mfc-ups)').forEach(function (el) { el.classList.remove('pr-routine'); el.classList.add('mfc-src-routine'); });

  /* ═══ case type: 'Tip husă: <name>' + the dropdown, built from the live cards ═══ */
  var typesEl = $('[data-pr-types]');
  var tWrap = $('[data-mfc-type]');
  var tSel = $('[data-mfc-tsel]');
  var tBtn = $('#mfc-tbtn');
  var tList = $('#mfc-tlist');
  var tName = $('[data-mfc-tname]');
  var dropEl = $('[data-mfc-drop]');
  var T = [], tSig = '', initType = '';

  function info(card) {
    var nEl = card.querySelector('.pr-type__name');
    var name = nEl ? String((nEl.childNodes[0] && nEl.childNodes[0].textContent) || nEl.textContent || '').replace(/\s+/g, ' ').trim() : '';
    var bEl = card.querySelector('.pr-type__badge--ink, .pr-type__badge--accent');
    var fEl = card.querySelector('.pr-type__finish');
    var gloss = fEl ? /lucios|glossy/i.test(fEl.textContent || '') : cfg.fin === 'lucios';
    /* the finish is only claimed where it is known: a merged pair's card or a Glossy product (an unpaired matt page
       also sells Transparent colours, so 'Mat' there would not be true) */
    var fin = !!fEl || cfg.fin === 'lucios';
    var mEl = card.querySelector('.pr-type__meter-val');
    var meter = mEl ? String(mEl.textContent || '').trim() : (/pro/i.test(name) ? '5 m' : '3,5 m');
    var pEl = card.querySelector('.pr-type__price');
    var was = '', now = '';
    if (pEl) {
      var sEl = pEl.querySelector('s');
      if (sEl) {
        was = String(sEl.textContent || '').trim();
        var nowEl = pEl.querySelector('span:not(.pr-type__off)');
        now = nowEl ? String(nowEl.textContent || '').trim() : '';
      } else { now = String(pEl.textContent || '').trim(); }
    }
    var im = card.querySelector('.pr-type__img img');
    return { card: card, name: name, badge: bEl ? String(bEl.textContent || '').trim() : '', gloss: gloss, fin: fin, meter: meter, was: was, now: now,
      img: im ? (im.getAttribute('src') || '') : '', on: card.classList.contains('is-active') };
  }
  function face(t, one) {
    return '<span class="mfc-tsel__img">' + (t.img ? '<img src="' + esc(t.img) + '" alt="" width="46" height="56">' : '') + '</span>' +
      '<span class="mfc-tsel__t"><b>' + esc(t.name) + (t.fin ? '<span class="mfc-fin' + (t.gloss ? ' mfc-fin--gl' : '') + '">' + esc(t.gloss ? cfg.finBL : cfg.finBM) + '</span>' : '') +
      (t.badge && !one ? '<span class="mfc-pop">' + esc(t.badge) + '</span>' : '') + '</b>' +
      '<small>' + esc((t.fin ? (t.gloss ? cfg.finL : cfg.finM) + ' · ' : '') + t.meter + ' ' + cfg.drop) + '</small></span>' +
      '<span class="mfc-tsel__p">' + (t.was ? '<s>' + esc(t.was) + '</s>' : '') + esc(t.now) + '</span>';
  }
  function active() { return T.filter(function (t) { return t.on; })[0] || T[0] || null; }
  /* the type's measurement slug, from the card the dropdown already reads: slim / full / pro (any other name squashed
     to 10 chars) + '_gl' where the card is glossy - a merged pair's glossy Full-Shock is full_gl, an unpaired matt
     page's Full-Shock is full */
  function tslug(t) {
    if (!t) { return 'none'; }
    var n = String(t.name || '').toLowerCase();
    var b = /slim/.test(n) ? 'slim' : (/pro/.test(n) ? 'pro' : (/full/.test(n) ? 'full' : (n.replace(/[^a-z0-9]+/g, '').slice(0, 10) || 'x')));
    return b + (t.gloss ? '_gl' : '');
  }
  /* page kind: pair = the merged glossy/matt page (product-rhode's GMD), solo = 2+ types unmerged, one = a single
     type (no dropdown), none = no type row. DEF = the type the page opened on. */
  var PAIR = !!(data.gm && data.gm.g && data.gm.m);
  var K = 'none', DEF = '', nOpen = 0;
  /* D (assets/mf-pdp-d.js) repaints its type cards after every repaint of the list here (empty in C) */
  var tHooks = [];
  function renderTypes() {
    if (!tWrap || !typesEl) { return; }
    T = $$('.pr-type', typesEl).map(info);
    if (!T.length) { tWrap.hidden = true; return; }
    tWrap.hidden = false;
    var act = active();
    var sig = JSON.stringify(T.map(function (t) { return [t.name, t.badge, t.gloss, t.fin, t.meter, t.was, t.now, t.img, t.on]; }));
    if (sig !== tSig) {
      tSig = sig;
      var focusI = tList.hidden ? -1 : $$('[role="option"]', tList).indexOf(D.activeElement);
      /* one case type only (e.g. the Nude on a 17 Pro Max): the face alone - no chevron, no 'most popular', no list */
      var one = T.length < 2;
      tSel.classList.toggle('is-one', one);
      if (one) {
        tOpen(false);
        tBtn.setAttribute('aria-disabled', 'true');
        tBtn.removeAttribute('aria-haspopup'); tBtn.removeAttribute('aria-expanded'); tBtn.removeAttribute('aria-controls');
      } else if (tBtn.getAttribute('aria-disabled')) {
        tBtn.removeAttribute('aria-disabled');
        tBtn.setAttribute('aria-haspopup', 'listbox'); tBtn.setAttribute('aria-expanded', 'false'); tBtn.setAttribute('aria-controls', 'mfc-tlist');
      }
      tBtn.innerHTML = face(act, one) + (one ? '' : CAR);
      tList.innerHTML = T.map(function (t, i) {
        return '<div class="mfc-tsel__opt" role="option" id="mfc-topt' + i + '" aria-selected="' + (t === act ? 'true' : 'false') + '" tabindex="-1" data-i="' + i + '">' + face(t) + '</div>';
      }).join('');
      if (focusI > -1 && tList.children[focusI]) { tList.children[focusI].focus({ preventScroll: true }); }
    }
    if (tName) { tName.textContent = act.name; }
    if (dropEl) { dropEl.textContent = act.meter; }
  }
  var tOpened = false;
  function tOpen(open) {
    if (!tList) { return; }
    if (T.length < 2) { open = false; }
    var wasOpen = !tList.hidden;
    tList.hidden = !open;
    if (tBtn.hasAttribute('aria-expanded')) { tBtn.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    tSel.classList.toggle('is-open', open);
    if (!open) { return; }
    var c = tList.querySelector('[aria-selected="true"]') || tList.firstElementChild;
    if (c) { try { c.focus({ preventScroll: true }); } catch (eF) { c.focus(); } }
    /* the list opens in place: on a short screen bring its end into view */
    var r = tList.getBoundingClientRect(), vh = W.innerHeight || 0;
    if (vh && r.bottom > vh - 12) { W.scrollBy({ top: r.bottom - vh + 24, behavior: smooth() }); }
    if (!tOpened) { tOpened = true; step('pdpc:tsel_open'); }
    step1('pdpc:open_' + K);
    if (!wasOpen && ++nOpen === 2) { step1('pdpc:open_2p'); }
  }
  function choose(i) {
    var t = T[i];
    tOpen(false);
    try { tBtn.focus({ preventScroll: true }); } catch (eF) { tBtn.focus(); }
    if (!t || t.on) { return; }
    var from = (active() || {}).name || '';
    /* mf-track books a type change from a TRUSTED click on a live card; this click is synthetic, so the same event
       goes out here, with the same fields */
    push('mf_pdp_option_change', { mf_option: 'type', mf_option_value: t.name, mf_option_from: from, mf_from_default: from && from === initType ? 'yes' : 'no' });
    t.card.click();
    /* what the dropdown switched to (':to_' rides mf-track's send priority), and a return to the opening type */
    var ts = tslug(t);
    step1('pdpc:chg_' + K);
    step1('pdpc:t:to_' + K + '_' + ts);
    if (ts === DEF) { step1('pdpc:t_back'); }
  }
  if (tWrap && typesEl && tBtn && tList) {
    renderTypes();
    /* read here, before any pick can run: product-rhode's script (above this file) dealt the default synchronously */
    K = T.length > 1 ? (PAIR ? 'pair' : 'solo') : (T.length ? 'one' : 'none');
    DEF = T.length ? tslug(active()) : '';
    new MutationObserver(raf(function () { renderTypes(); paintCta(); tHooks.forEach(function (f) { try { f(); } catch (eH) {} }); })).observe(typesEl, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'src'] });
    tBtn.addEventListener('click', function () { tOpen(tList.hidden); });
    tBtn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); tOpen(true); }
    });
    tList.addEventListener('click', function (e) {
      var o = e.target && e.target.closest ? e.target.closest('[data-i]') : null;
      if (o) { choose(+o.getAttribute('data-i')); }
    });
    tList.addEventListener('keydown', function (e) {
      var opts = $$('[role="option"]', tList), i = opts.indexOf(D.activeElement), n = opts.length;
      if (!n) { return; }
      if (i < 0) { i = Math.max(0, opts.indexOf(tList.querySelector('[aria-selected="true"]'))); }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); opts[(i + (e.key === 'ArrowDown' ? 1 : n - 1)) % n].focus(); }
      else if (e.key === 'Home') { e.preventDefault(); opts[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); opts[n - 1].focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(i); }
      else if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopPropagation(); tOpen(false); tBtn.focus(); }
      else if (e.key === 'Tab') { tOpen(false); }
    });
    D.addEventListener('click', function (e) {
      if (!tList.hidden && !(e.target && e.target.closest && e.target.closest('[data-mfc-tsel]'))) { tOpen(false); }
    });
    W.setTimeout(function () { initType = (active() || {}).name || ''; }, 1200);
  }

  /* swatches: the live painter puts the colour on the button itself; C draws a smaller dot in a bigger hit area */
  var swEl = $('[data-pr-swatches]');
  function paintSw() {
    if (!swEl) { return; }
    $$('.pr-sw', swEl).forEach(function (b) {
      var c = b.style.backgroundColor || '';
      if (c && b.style.getPropertyValue('--mfc-sw') !== c) { b.style.setProperty('--mfc-sw', c); }
    });
  }
  if (swEl) { paintSw(); new MutationObserver(paintSw).observe(swEl, { childList: true }); }

  /* ═══ the folie rows (owner 2026-10-07): one row per protector - Pro-Shield, then NanoGlass - each its own checkbox
     over its own live card [data-pr-up-kind="ps|ng"]. No picker: the two ticks are independent (both may be on),
     exactly like the live cards they drive. Each row carries data-k / data-was / data-now (cents, the -30% face) ═══ */
  function liveUp(k) { return root.querySelector('[data-pr-up][data-pr-up-kind="' + k + '"]'); }
  var P = [];
  $$('[data-mfc-prot]').forEach(function (el) {
    var k = el.getAttribute('data-k');
    var cb = $('[data-mfc-prot-cb]', el);
    /* a row whose live card is missing (e.g. a protector page renders no live set) cannot sell: it goes */
    if (!cb || (k !== 'ps' && k !== 'ng') || !liveUp(k)) { el.parentNode.removeChild(el); return; }
    var nEl = $('[data-mfc-prot-n]', el);
    P.push({ el: el, k: k, cb: cb, was: parseInt(el.getAttribute('data-was'), 10) || 0, now: parseInt(el.getAttribute('data-now'), 10) || 0,
      name: nEl ? String(nEl.textContent || '').replace(/\s+/g, ' ').trim() : '' });
  });
  /* what the ticked rows add to the CTA total, and their names for the float bar's sub line */
  function protCents() {
    var c = 0;
    P.forEach(function (p) { if (p.cb.checked) { c += p.now; } });
    return c;
  }
  function protNames() { return P.filter(function (p) { return p.cb.checked; }).map(function (p) { return p.name; }); }
  function paintProt(p) {
    var pp = $('[data-mfc-prot-p]', p.el);
    /* the price column in the section's own money format (the Liquid wrote it with money_without_trailing_zeros) */
    if (pp && !pp.__mfc) { pp.__mfc = true; pp.innerHTML = (p.was > p.now ? '<s>' + esc(money(p.was)) + '</s>' : '') + '<b>+' + esc(money(p.now)) + '</b>'; }
    p.el.classList.toggle('is-on', !!p.cb.checked);
  }
  /* the row's live card is pressed / released with a click, so its own handler books upsell_select / _v2 /
     ups:<ps|ng>_pick; mf-track's upsell_add (trusted clicks only - it books every trusted live-card click, on or off)
     is sent here instead. A 'change' on a row only ever comes from a user: the row's own tick, or D's card tap
     (mf-pdp-d.js dispatches it); the restore below sets .checked without an event. */
  function syncProt(p, trusted) {
    var b = liveUp(p.k);
    if (!b) { return; }
    if (!!p.cb.checked === (b.getAttribute('aria-pressed') === 'true')) { return; }
    b.click();
    if (trusted) {
      var nm = b.querySelector('.pr-up__name');
      push('mf_pdp_step', { mf_step: 'upsell_add', mf_variant_id: String(b.getAttribute('data-variant-id') || ''), mf_up_name: nm ? String(nm.textContent || '').replace(/\s+/g, ' ').trim() : '' });
    }
  }
  P.forEach(function (p) {
    /* a restored form must not tick a row whose live card is not pressed */
    p.cb.checked = false;
    paintProt(p);
    p.cb.addEventListener('change', function () {
      syncProt(p, true);
      paintProt(p);
      paintCta();
      /* which folie was ticked on ('pdpc:fol_ps' / 'pdpc:fol_ng'; it used to fire on the old select's change). Booked
         HERE only - this change path is the one place every tick passes through, C's own and D's card tap alike, so
         mf-pdp-d.js does not book it (step1 dedupes per pageview as a second guard) */
      if (p.cb.checked) { step1('pdpc:fol_' + p.k); }
    });
  });

  /* ═══ the Mystery Cadou strip (owner 2026-10-07: D's green gift strip, now C's own): pre-ticked; unticked, the
     live card's gift id goes to 0 and the CTA adds no gift ═══ */
  var gift = $('[data-mfc-gift]');
  var liveGift = $('[data-pr-gift]');
  var mgB = /\bmf-mg-b\b/.test(D.documentElement.className);
  if (gift && (!liveGift || !mgB)) { gift.parentNode.removeChild(gift); gift = null; }
  if (gift) {
    var gid = liveGift.getAttribute('data-promo-variant') || '';
    var gcb = $('[data-mfc-gift-cb]', gift);
    gcb.checked = true;
    gcb.addEventListener('change', function () {
      liveGift.setAttribute('data-promo-variant', gcb.checked ? gid : '0');
      gift.classList.toggle('is-on', gcb.checked);
      step(gcb.checked ? 'pdpc:gift_on' : 'pdpc:gift_off');
    });
    /* 'Cum funcționează?' (snippets/mf-gift-howto.liquid opens the drawer from a document listener; it books nothing) */
    gift.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-mgh-open]')) { step1('pdpc:gift_howto'); }
    });
    /* a tap anywhere on the strip toggles the tick; the tick, its label and the how-to link keep their own behaviour
       (the label already toggles the box natively - a second toggle here would undo it). The ONLY strip handler:
       mf-pdp-d.js no longer binds one, two would toggle twice = no change. */
    gift.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest || t.closest('label, input, button, a, [data-mgh-open]')) { return; }
      gcb.click();
    });
  }
  var ups = $('[data-mfc-ups]');
  if (ups && !ups.querySelector('.mfc-up')) { ups.parentNode.removeChild(ups); }

  /* ═══ CTA + float bar: 'ADAUGĂ ÎN COȘ · <case + folie>', the bar with picture, name, type and price ═══ */
  var cta = $('[data-pr-cta]');
  var fBar = D.querySelector('[data-pr-float]');
  var fCta = fBar ? fBar.querySelector('[data-pr-float-cta]') : null;
  var barImg = null, barSub = null, lastLive = cta ? String(cta.textContent || '').trim() : '', ctaMo = null, total = 0;
  if (fBar) {
    var bi = D.createElement('span');
    bi.className = 'mfc-bar__img';
    bi.innerHTML = '<img alt="" width="48" height="48">';
    fBar.insertBefore(bi, fBar.firstChild);
    barImg = bi.firstChild;
    barSub = D.createElement('small');
    barSub.className = 'mfc-bar__sub';
    (fBar.querySelector('.pr-float__row') || fBar).appendChild(barSub);
  }
  function paintCta(live) {
    if (!cta) { return; }
    if (ctaMo && ctaMo.takeRecords().length) { live = true; }
    if (live) { lastLive = String(cta.textContent || '').trim(); }
    var lbl = lastLive, at = lastLive.lastIndexOf(' · ');
    total = 0;
    if (!cta.disabled && at > -1) {
      total = cents(lastLive.slice(at + 3)) + protCents();
      lbl = lastLive.slice(0, at) + ' · ' + money(total);
    }
    if (String(cta.textContent || '').trim() !== lbl) { cta.textContent = lbl; }
    if (fCta) {
      var fl = cta.disabled ? lastLive : (cfg.barCta || lbl);
      if (fCta.textContent !== fl) { fCta.textContent = fl; }
      fCta.setAttribute('aria-label', lbl);
    }
    if (ctaMo) { ctaMo.takeRecords(); }
    paintBar();
  }
  /* full-price mode OFF (2026-10-09): the bar's struck original. C hides the live .pr-float__anchor (no room for a
     second row in the 64px bar), so its figures move into the sub line instead. Read from that anchor, which
     product-rhode fills in the same tick as the CTA text (this file's observer runs after it): the case's compare,
     plus each ticked folie at its own struck price (data-was, or data-now when it has none), so the strike and the
     total it sits beside cover the same goods. 0 = no strike: full-price mode (product-rhode nulls compare_at and
     keeps the anchor hidden there - checked here directly as well), a variant without a compare, sold out. */
  function barCmp() {
    if (data.fullPrice === true || !fBar || !cta || cta.disabled) { return 0; }
    var fa = fBar.querySelector('[data-pr-float-anchor]');
    if (!fa || fa.hidden) { return 0; }
    var c = cents((fa.querySelector('[data-pr-float-compare]') || {}).textContent);
    if (!c) { return 0; }
    P.forEach(function (p) { if (p.cb.checked) { c += Math.max(p.was, p.now); } });
    return c;
  }
  /* the bare amount for the strike (no currency: it sits right before the full price, and the bar is narrow) */
  function amt(c) {
    var v = (c || 0) / 100;
    return noDec ? String(Math.round(v)) : ((v % 1 === 0) ? v.toFixed(0) : v.toFixed(2).replace('.', ','));
  }
  function paintBar() {
    if (!barSub || !cta) { return; }
    var a = active(), pn = protNames();
    var what = a ? a.name + (pn.length ? ' + ' + pn.join(' + ') : '') : '';
    var cmp = barCmp();
    if (cmp > total && total > 0) {
      /* 'Full-Shock · ~~284~~ 199 RON -30%': the price part never shrinks, the type name gives way (ellipsis)
         first, so the bar stays one line at 360px. The cut is of the bar's own total - exactly the hero's -30%
         when no folie is ticked. */
      var off = Math.round((1 - total / cmp) * 100);
      barSub.textContent = '';
      barSub.classList.add('mfc-bar__sub--cmp');
      if (what) {
        var w = D.createElement('span');
        w.className = 'mfc-bar__what';
        w.textContent = what;
        barSub.appendChild(w);
      }
      var px = D.createElement('span');
      px.className = 'mfc-bar__px';
      px.appendChild(D.createTextNode(what ? '· ' : ''));
      var s = D.createElement('s');
      s.textContent = amt(cmp);
      px.appendChild(s);
      var b = D.createElement('b');
      b.textContent = money(total);
      px.appendChild(b);
      if (off > 0) {
        var o = D.createElement('span');
        o.className = 'mfc-bar__off';
        o.textContent = '-' + off + '%';
        px.appendChild(o);
      }
      barSub.appendChild(px);
      return;
    }
    if (barSub.classList.contains('mfc-bar__sub--cmp')) { barSub.classList.remove('mfc-bar__sub--cmp'); }
    barSub.textContent = (a ? what + ' · ' : '') + (cta.disabled ? lastLive : money(total));
  }
  var barShown = false;
  function paintBarImg() {
    if (!barImg || !barShown) { return; }
    var st = $('[data-pr-stage]');
    var im = st ? st.querySelector('.pr-media__slide:not([hidden]) img') : null;
    var src = im ? (im.getAttribute('src') || '') : '';
    if (/[?&]width=\d+/.test(src)) { src = src.replace(/([?&])width=\d+/, '$1width=160'); }
    if (src && barImg.getAttribute('src') !== src) { barImg.setAttribute('src', src); }
  }
  if (cta) {
    ctaMo = new MutationObserver(function () { paintCta(true); });
    ctaMo.observe(cta, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    if (fCta) { ctaMo.observe(fCta, { childList: true, characterData: true, subtree: true }); }
    paintCta(true);
  }
  if (fBar) {
    /* C has no sticky bar on desktop (the CSS hides it from 1000px): the live scroll code still marks it
       .is-visible there, and mf-track books 'pdp:float_impression' off that class - so on desktop the class comes
       straight off again. This observer is created before mf-track's (deferred), so it runs first and mf-track's
       sees no class: the Mostani and C desktop funnels stay comparable. */
    var deskMq = W.matchMedia ? W.matchMedia('(min-width: 1000px)') : null;
    new MutationObserver(function () {
      if (!fBar.classList.contains('is-visible')) { return; }
      if (deskMq && deskMq.matches) { fBar.classList.remove('is-visible'); fBar.setAttribute('aria-hidden', 'true'); return; }
      if (!barShown) { barShown = true; paintBarImg(); }
    }).observe(fBar, { attributes: true, attributeFilter: ['class'] });
    /* the bar's picture is set once the page has loaded (a 160px thumb, after the gallery), so the bar never
       slides in with an empty square */
    var barLate = function () { if (!barShown) { barShown = true; paintBarImg(); } };
    if (D.readyState === 'complete') { W.setTimeout(barLate, 0); } else { W.addEventListener('load', function () { W.setTimeout(barLate, 300); }, false); }
  }

  /* ═══ 1+1 (owner 2026-10-07, as D had it): the live strip moves right under the hero price [data-pr-heroprice] -
     a full-width lilac block (mf-pdp-c.css). Moving the node is safe: assets/promo22.js only checks that
     [data-promo22-pdp] exists (pdp_view), nothing reads its position, and it carries no listeners. The copy: the
     dash as an en dash, 'CADOU' the one bold word ('La 2 huse, cea mai ieftină e <b>CADOU</b> – se aplică…'); a
     merchant text without CADOU keeps the first clause bold instead. ═══ */
  (function () {
    var hero = $('[data-pr-heroprice]'), p22 = $('[data-promo22-pdp]');
    if (hero && p22 && hero.nextSibling !== p22) { hero.parentNode.insertBefore(p22, hero.nextSibling); }
    $$('[data-promo22-pdp] > span:not(.pr-promo22__tag)').forEach(function (sp) {
      if (sp.querySelector('b')) { return; }
      var tx = String(sp.textContent || '').replace(/\s+/g, ' ').trim(), m = tx.match(/^(.+?)\s+[-–—]\s+(.+)$/);
      if (/\bCADOU\b/.test(tx)) {
        if (m) { tx = m[1] + ' – ' + m[2]; }
        sp.innerHTML = esc(tx).replace(/\bCADOU\b/, '<b>CADOU</b>');
      } else if (m) { sp.innerHTML = '<b>' + esc(m[1]) + '</b> – ' + esc(m[2]); }
    });
  })();

  /* ═══ Telefon: C names the phone without the brand ('iPhone 15', not 'Apple iPhone 15') ═══ */
  function devLabel() {
    var tr = $('[data-pr-dd-trigger]');
    if (!tr || tr.children.length) { return; }
    var tx = String(tr.textContent || ''), nx = tx.replace(/^\s*Apple\s+/, '');
    if (nx !== tx) { tr.textContent = nx; }
  }
  devLabel();
  D.addEventListener('DOMContentLoaded', devLabel);
  /* the picker opened / searched (the switch itself is mf-track's device_change); the section's trigger handler is
     bound first, so is-open already says what this click did */
  (function () {
    var dd = $('[data-pr-device-root]'), tr = $('[data-pr-dd-trigger]'), q = $('[data-pr-dd-search]');
    if (dd && tr) { tr.addEventListener('click', function () { if (dd.classList.contains('is-open')) { step1('pdpc:dev_open'); } }); }
    if (q) { q.addEventListener('input', function () { step1('pdpc:dev_q'); }); }
  })();

  /* ═══ MagSafe as the type's only option: the live toggle is locked on - it reads 'MagSafe inclus' ═══ */
  var msBtn = $('[data-pr-magsafe-btn]');
  function paintMs() {
    if (!msBtn) { return; }
    var inc = msBtn.disabled && msBtn.getAttribute('aria-pressed') === 'true';
    msBtn.classList.toggle('mfc-ms-inc', inc);
    var lb = msBtn.firstElementChild;
    if (inc && lb && lb.textContent !== (cfg.msInc || 'MagSafe inclus')) { lb.textContent = cfg.msInc || 'MagSafe inclus'; }
  }
  if (msBtn) { paintMs(); new MutationObserver(paintMs).observe(msBtn, { childList: true, attributes: true, attributeFilter: ['disabled', 'aria-pressed'] }); }
  /* MagSafe switched ON (mf-track's option:magsafe books any toggle; the beacon drops its on/off value). The live
     handler, bound first, sets aria-pressed synchronously; read one tick later to be safe. */
  if (msBtn) {
    msBtn.addEventListener('click', function () {
      W.setTimeout(function () { if (msBtn.getAttribute('aria-pressed') === 'true') { step1('pdpc:ms_on'); } }, 0);
    });
  }

  /* ═══ gallery: dots on phones, the packshot thumbs contained on desktop ═══ */
  var stage = $('[data-pr-stage]');
  var nav = $('[data-pr-nav]');
  var dots = null, dSig = '';
  function vis() {
    return stage ? [].filter.call(stage.children, function (el) {
      return el.classList.contains('pr-media__slide') && !el.hidden && W.getComputedStyle(el).display !== 'none';
    }) : [];
  }
  function padL() { return stage ? (parseFloat(W.getComputedStyle(stage).paddingLeft) || 0) : 0; }
  function curIdx(v) {
    var best = 0, bd = Infinity, pl = padL();
    v.forEach(function (el, i) { var d = Math.abs(el.offsetLeft - pl - stage.scrollLeft); if (d < bd) { bd = d; best = i; } });
    return best;
  }
  function curDot() {
    if (!dots) { return; }
    var v = vis(), i = curIdx(v);
    [].forEach.call(dots.children, function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
  }
  function buildDots() {
    if (!dots) { return; }
    var v = vis();
    var sig = v.map(function (el) { return el.getAttribute('data-pr-media'); }).join(',');
    if (sig !== dSig) {
      dSig = sig;
      dots.hidden = v.length < 2;
      dots.innerHTML = v.map(function (el, i) {
        return '<button type="button" data-i="' + i + '" aria-label="' + esc((cfg.dot || 'Imaginea') + ' ' + (i + 1) + ' ' + (cfg.of || 'din') + ' ' + v.length) + '"></button>';
      }).join('');
    }
    curDot();
  }
  function markPk() {
    if (!nav || !stage) { return; }
    $$('.pr-media__thumb', nav).forEach(function (t) {
      var sl = stage.querySelector('.pr-media__slide[data-pr-media="' + t.getAttribute('data-pr-thumb') + '"]');
      t.classList.toggle('mfc-pk', !!(sl && !sl.hasAttribute('data-mfg') && sl.querySelector('img.pr-media--shot')));
    });
  }
  if (stage) {
    dots = D.createElement('div');
    dots.className = 'mfc-dots';
    dots.setAttribute('role', 'group');
    dots.setAttribute('aria-label', cfg.dots || 'Imagini');
    stage.parentNode.insertBefore(dots, stage.nextSibling);
    dots.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-i]') : null;
      if (!b) { return; }
      var el = vis()[+b.getAttribute('data-i')];
      if (el) { stage.scrollTo({ left: el.offsetLeft - padL(), behavior: smooth() }); }
    });
    dots.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('[data-i]')) { step1('pdpc:gal_dot'); } });
    stage.addEventListener('scroll', raf(curDot), { passive: true });
    var galSync = raf(function () { buildDots(); markPk(); paintBarImg(); });
    new MutationObserver(galSync).observe(stage, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'src', 'data-pr-media'] });
    if (nav) { new MutationObserver(galSync).observe(nav, { childList: true, attributes: true, subtree: true, attributeFilter: ['data-pr-thumb', 'hidden'] }); }
    W.addEventListener('resize', raf(curDot));
    buildDots(); markPk();
    /* the section recomposes the lifestyle set 40 ms after DOMContentLoaded */
    D.addEventListener('DOMContentLoaded', function () { W.setTimeout(galSync, 120); });
  }

  /* ═══ Completează-ți setul: tick tiles, pick variants, one outlined button adds the selection ═══ */
  var tiles = $$('[data-mfc-tile]');
  var setBtn = $('[data-mfc-setadd]');
  var setErr = $('[data-mfc-set-err]');
  function tileVar(t) {
    var sel = t.querySelector('[data-mfc-tsel-v]');
    if (sel) {
      var o = sel.options[sel.selectedIndex];
      return o ? { id: parseInt(o.value, 10), price: parseInt(o.getAttribute('data-price'), 10) || 0, img: o.getAttribute('data-img') || '' } : null;
    }
    var one = t.querySelector('[data-mfc-v1]');
    return one ? { id: parseInt(one.getAttribute('data-mfc-v1'), 10), price: parseInt(one.getAttribute('data-price'), 10) || 0, img: '' } : null;
  }
  function picked() { return tiles.filter(function (t) { var cb = t.querySelector('[data-mfc-tcb]'); return cb && cb.checked; }); }
  function paintSet() {
    if (!setBtn) { return; }
    var p = picked(), sum = 0;
    p.forEach(function (t) { var v = tileVar(t); if (v) { sum += v.price; } });
    setBtn.setAttribute('aria-disabled', p.length ? 'false' : 'true');
    setBtn.textContent = (cfg.setLabel || '') + (p.length ? ' · ' + p.length + ' ' + (p.length === 1 ? cfg.setN1 : cfg.setN) + ' · ' + money(sum) : '');
  }
  tiles.forEach(function (t) {
    var cb = t.querySelector('[data-mfc-tcb]'), sel = t.querySelector('[data-mfc-tsel-v]');
    if (!cb) { return; }
    var nm = (t.querySelector('.mfc-tile__n') || {}).textContent || '';
    cb.checked = false;
    if (sel) {
      var dflt = sel.querySelector('option[selected]');
      if (dflt) { sel.value = dflt.value; }
    }
    cb.addEventListener('change', function () { t.classList.toggle('is-on', cb.checked); paintSet(); });
    /* which tile was ticked ('pdpc:tile_crossbody'); a variant pick ticks the tile too */
    var tk = 'pdpc:tile_' + (String(nm).toLowerCase().replace(/[^a-z0-9]+/g, '').slice(0, 14) || 'x');
    cb.addEventListener('change', function () { if (cb.checked) { step1(tk); } });
    if (sel) { sel.addEventListener('change', function () { step1('pdpc:set_var'); step1(tk); }); }
    if (sel) {
      sel.addEventListener('change', function () {
        var v = tileVar(t);
        if (!v) { return; }
        var im = t.querySelector('[data-mfc-timg]');
        if (im && v.img) { im.setAttribute('src', v.img); }
        var tp = t.querySelector('[data-mfc-tp]');
        if (tp) { tp.textContent = money(v.price); }
        cb.setAttribute('aria-label', nm + ', ' + money(v.price));
        if (!cb.checked) { cb.checked = true; t.classList.add('is-on'); }
        paintSet();
      });
    }
  });
  function addSet(items) {
    function send() {
      return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items, sections: 'mini-cart' }) });
    }
    return send().then(function (r) {
      return r.status === 429 ? new Promise(function (res) { W.setTimeout(res, 1200); }).then(send) : r;
    }).then(function (r) {
      if (!r.ok) {
        return r.json().catch(function () { return {}; }).then(function (b) { var er = new Error('add'); er.desc = b && b.description; throw er; });
      }
      return r.json();
    });
  }
  /* the section's own after-add path: paint the drawer from the add's sections, then one shared /cart.js */
  function afterAdd(d) {
    if (W.mfCart) { W.mfCart.invalidate(); }
    var sections = d && d.sections, painted = !!(sections && sections['mini-cart']);
    if (painted) {
      var added = 0;
      ((d && d.items) || []).forEach(function (l) { added += (l.quantity || 0); });
      var known = W.mfCart ? W.mfCart.count() : 0;
      D.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: { item_count: (known || 0) + added, sections: sections } } }));
    }
    var dr = D.querySelector('cart-drawer');
    if (dr) { dr.open = true; }
    var load = W.mfCart ? W.mfCart.get() : fetch('/cart.js').then(function (r) { return r.json(); });
    return load.then(function (cart) {
      if (cart && cart.item_count > 0) { $$('cart-count.visually-hidden', D).forEach(function (el) { el.classList.remove('visually-hidden'); }); }
      D.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      if (!painted) {
        D.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
        if (dr) { dr.open = true; }
      }
    });
  }
  if (setBtn) {
    paintSet();
    setBtn.addEventListener('click', function () {
      var p = picked();
      if (!p.length || setBtn.getAttribute('aria-busy') === 'true') { return; }
      var items = [];
      p.forEach(function (t) { var v = tileVar(t); if (v && v.id) { items.push({ id: v.id, quantity: 1 }); } });
      if (!items.length) { return; }
      setBtn.setAttribute('aria-busy', 'true');
      if (setErr) { setErr.hidden = true; }
      addSet(items).then(function (d) {
        step('pdpc:set_add');
        tiles.forEach(function (t) { var cb = t.querySelector('[data-mfc-tcb]'); if (cb) { cb.checked = false; } t.classList.remove('is-on'); });
        paintSet();
        return afterAdd(d);
      }).catch(function (e) {
        if (!setErr) { return; }
        setErr.textContent = (e && e.desc) || cfg.err || '';
        setErr.hidden = !setErr.textContent;
        W.clearTimeout(setErr._t);
        setErr._t = W.setTimeout(function () { setErr.hidden = true; }, 6000);
      }).then(function () { setBtn.removeAttribute('aria-busy'); });
    });
  }

  /* ═══ today's video row keeps its Mostani place: above the accordions (product-rhode renders it after C's 'after'
     part; moving the node keeps the live script's listeners and observer) ═══ */
  (function () {
    var ac = $('[data-mfc-accs]');
    [$('.pr-designs'), $('[data-pr-vrow]')].forEach(function (el) {
      if (el && ac && el.parentNode === ac.parentNode) { ac.parentNode.insertBefore(el, ac); }
    });
    /* the restored facts row: returns are at the customer's cost (RETURURI ȘI RAMBURSĂRI), so no 'gratuit' in C -
       the template text itself is the owner's to change (it also feeds Mostani) */
    $$('.prx-fact dd').forEach(function (dd) {
      var t = dd.textContent || '';
      if (/retur gratuit/i.test(t)) { dd.textContent = t.replace(/retur gratuit/i, 'Retur în'); }
    });
  })();

  /* ═══ accordions ═══ */
  $$('.mfc-acc__h').forEach(function (h) {
    h.addEventListener('click', function () {
      var open = h.getAttribute('aria-expanded') !== 'true';
      var b = D.getElementById(h.getAttribute('aria-controls'));
      h.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (b) {
        b.classList.toggle('is-open', open);
        if (open) { b.removeAttribute('inert'); } else { b.setAttribute('inert', ''); }
      }
    });
  });

  /* ═══ element measurement (2026-10-07): which accordion, the set's link, the rail ═══ */
  /* accordion by role, not by its (editable) title: mfc-acch1..4 = Descriere / Compatibilitate / types / Livrare */
  $$('.mfc-acc__h').forEach(function (h) {
    var m = /^mfc-acch(\d)$/.exec(h.id || '');
    var role = m ? (['', 'desc', 'comp', 'types', 'ship'][+m[1]] || 'more') : 'more';
    /* bound after the toggle above, so aria-expanded is already the new state: opens only */
    h.addEventListener('click', function () { if (h.getAttribute('aria-expanded') === 'true') { step1('pdpc:acc_' + role); } });
  });
  var setMore = $('.mfc-tile--more');
  if (setMore) { setMore.addEventListener('click', function () { step1('pdpc:set_more'); }); }
  /* the recommended rail under the section (templates/product.json 'ajax_rail'; the social rail has no links) */
  D.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (a && a.closest('.shopify-section--ajax-collection, [id*="ajax_rail"]')) { step1('pdpc:rail_rec'); }
  }, true);

  /* the C page view, after load (mf-track is deferred: the live pattern - load + one retry) */
  var viewSent = false;
  function sendView() {
    if (!viewSent && W.mfTrackPush) {
      viewSent = true; step('pdpc:view');
      /* the C/D test (Termékoldal = 'cd', 2026-10-07): the arm as a key on EVERY C-face view - pfv:c / pfv:d - so
         mf-track's add / checkout joins (step_add / step_chk) carry it on this pageview; mf-track sorts pfv: / pfs:
         first, so the 24-key join lists cannot drop it. window.__mfPF exists only where theme.liquid's dealer
         rendered ('cd' mode); 'x' (storage failed, excluded) and a stale tab without the dealer send nothing.
         pfv:miss = the arm and the section's .mfpd disagree (the head part's class script did not run, or ran
         wrong) - a health check that should stay ~0. */
      var pf = W.__mfPF;
      if (pf === 'c' || pf === 'd') {
        step1('pfv:' + pf);
        if ((pf === 'd') !== root.classList.contains('mfpd')) { step1('pfv:miss'); }
      }
      /* D's face: one key per view next to pdpc:view - only where the section really carries .mfpd. In 'cd' mode the
         config's "d":1 is on the page for BOTH arms (the D layer loads for both), so cfg.d alone would tag arm C's
         views as D; for plain 'd' the server sets .mfpd, so this reads exactly as before. */
      if (cfg.d && root.classList.contains('mfpd')) { step1('pdpc:face_d'); }
      /* the opening type with the page kind (the dropdown's denominator), and - only where one is missing - which rows
         this page did NOT offer (f folie = neither folie row, g gift, t accessory tiles), so the common page costs one
         key, not two */
      step1('pdpc:def_' + K + (DEF ? '_' + DEF : ''));
      var no = (P.length ? '' : 'f') + (gift ? '' : 'g') + (tiles.length ? '' : 't');
      if (no) { step1('pdpc:no_' + no); }
    }
  }
  function viewLate() { W.setTimeout(sendView, 0); W.setTimeout(sendView, 1500); }
  if (D.readyState === 'complete') { viewLate(); } else { W.addEventListener('load', viewLate, false); }

  /* QA hook (tests drive the page through it) */
  W.__mfPdpC = { types: function () { return T; }, open: tOpen, choose: choose, paint: function () { renderTypes(); paintCta(true); buildDots(); },
    /* D's handles: the per-view key sender and the type-list hook */
    step1: step1, onTypes: function (f) { tHooks.push(f); } };
})();
